export default{
  tipoPassagemVoo: {
    value: null,
    options: [],
    required: true,
    state: null,
    code: null
  },
  dataInicioVoo: {
    value: null,
    options: [],
    required: true,
    state: null,
    code: null
  },
  dataFimVoo: {
    value: null,
    options: [],
    required: true,
    state: null,
    code: null
  },
  dataDespesa: {
    value: null,
    options: [],
    required: true,
    state: null,
    code: null
  },
  quantidade: {
    value: '1',
    options: [],
    required: true,
    state: null,
    code: null
  },
  somenteArea: {
    value: true,
    options: [],
    required: false,
    state: null,
    code: null
  },
  paisOrigemFlyID: {
    value: null,
    options: [],
    required: true,
    state: null,
    code: null
  },
  estadoOrigemFlyID: {
    value: null,
    options: [],
    required: true,
    state: null,
    code: null
  },
  cidadeOrigemFlyId: {
    value: null,
    options: [],
    required: true,
    state: null,
    code: null
  },
  paisDestinoFlyID: {
    value: null,
    options: [],
    required: true,
    state: null,
    code: null
  },
  estadoDestinoFlyID: {
    value: null,
    options: [],
    required: true,
    state: null,
    code: null
  },
  cidadeDestinoFlyId: {
    value: null,
    options: [],
    required: true,
    state: null,
    code: null
  },
  observacao: {
    value: null,
    options: [],
    required: false,
    state: null,
    code: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/travelreimbursement/components/TravelAirPlaneModal/form-air.js